const CategoryOptions = {
  General: "General",
  Discussions: "Discussions",
  Technology: "Technology",
  Entertainment: "Entertainment",
  Gaming: "Gaming",
  Sports: "Sports",
  BooksAndLiterature: "Books and Literature",
  Travel: "Travel",
  FoodAndCooking: "Food and Cooking",
  HealthAndFitness: "Health and Fitness",
  ArtAndCreativity: "Art and Creativity",
  ScienceAndNature: "Science and Nature",
  PoliticsAndNews: "Politics and News",
  Education: "Education",
  Parenting: "Parenting",
  MusicAndInstruments: "Music and Instruments",
};

export default CategoryOptions;
